const defaultWallpaper = 'brand/openx_fallback/201804/index.html';

export default {
  host: 'https://backgrounds.wetransfer.net',

  // When media or provider fail.. this is what we show.
  defaultMedia: {
    src: defaultWallpaper,
    timer: 10000, // The fallback should switch (retry real advert) more quickly
  },

  onboarding: [
    {
      src: 'wetransfer/product/1804/onboarding1_v1/index.html',
    },
  ],

  // Rotate interval in milliseconds (default / for non-OpenX wallpapers)
  rotate: 30000,

  // Animation settings
  transition: {
    mobileHA: true,
    duration: 500,
    easing: 'ease', // [cubic bezier quartz-in-out]
  },

  // HTML5 or static images. No more Adobe Flash™®©.
  media: [{ src: defaultWallpaper, title: 'WeTransfer' }],

  dev: {
    enabled: __DEV__ && __WALLPAPER_DEV_ENABLED__ === true,
    // Provide as many wallpapers as needed. The `src` property MUST have `.html` extension
    // [
    //   { src: 'https://backgrounds.wetransfer.net/vodafone/201710/spinnertest_v1/index.html' },
    //   { src: 'http://office-01.local/HTML_Testing/nike/201802/scrubber_v1/index.html' }
    // ]
    wallpapers: [],
  },
};
